<template>
  <transition name="modal">
    <div v-if="modelValue" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div class="bg-white rounded-lg shadow-2xl max-w-md w-full mx-4 animate-fade-in text-black">
        <!-- Header -->
        <div class="flex justify-between items-center p-6 border-b">
          <h2 class="text-xl font-bold text-black">{{ title }}</h2>
          <button
            @click="$emit('update:modelValue', false)"
            class="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ✕
          </button>
        </div>

        <!-- Content -->
        <div class="p-6 text-black">
          <slot />
        </div>

        <!-- Footer -->
        <div class="flex justify-end gap-3 p-6 border-t text-black">
          <button
            @click="$emit('update:modelValue', false)"
            class="btn-secondary"
          >
            Cancelar
          </button>
          <button
            @click="$emit('confirm')"
            class="btn-primary"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script setup>
defineProps({
  modelValue: Boolean,
  title: String
})

defineEmits(['update:modelValue', 'confirm'])
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>
